import { ca } from '@cian/analytics';
import { IAnalyticsUser } from '../types/analytics/user';
import { TRequestCallbackOpener } from '../types/requestCallback';

export function trackCallbackPopupOpen(label: string, placeType: TRequestCallbackOpener) {
  ca('eventSite', {
    action: `CallBack_popup_open_${placeType}`,
    category: 'CardJK',
    label,
    name: 'oldevent',
    useLastProducts: true,
  });
}

interface ITrackSendCallbackSendParams {
  label: string;
  placeType: TRequestCallbackOpener;
  user?: IAnalyticsUser;
}

export function trackCallbackPopupSend({ label, placeType, user }: ITrackSendCallbackSendParams) {
  ca('eventSite', {
    action: `CallBack_popup_send_${placeType}`,
    category: 'CardJK',
    label,
    name: 'oldevent',
    useLastProducts: true,
    user,
  });
}

interface ITrackCallbackSendSimilarParams {
  label: string;
  newbuildingId: number;
  position: number;
  placeType: TRequestCallbackOpener;
  user: IAnalyticsUser;
}

export function trackCallbackSimilarSend({
  label,
  newbuildingId,
  position,
  placeType,
  user,
}: ITrackCallbackSendSimilarParams) {
  ca('eventSite', {
    action: `CallBack_popup_send_${placeType}`,
    category: 'CardJK',
    label,
    name: 'oldevent',
    products: [
      {
        extra: { is_similar: true },
        id: newbuildingId,
        offerType: 'JK',
        position,
      },
    ],
    user,
  });
}

export function trackRecommendationsToggleOn() {
  ca('eventSite', {
    action: 'CallBack_popup_toggle_recommendations_On',
    category: 'CardJK',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackRecommendationsToggleOff() {
  ca('eventSite', {
    action: 'CallBack_popup_toggle_recommendations_Off',
    category: 'CardJK',
    name: 'oldevent',
    useLastProducts: true,
  });
}
